module.exports = __webpack_public_path__ + "img/visit-tuscaloosa-logo.584abc74.jpg";